export enum PhoneType {
  FIXED_LINE = 'FIXED_LINE',
  MOBILE = 'MOBILE',
  FIXED_LINE_OR_MOBILE = 'FIXED_LINE_OR_MOBILE',
  TOLL_FREE = 'TOLL_FREE',
  PREMIUM_RATE = 'PREMIUM_RATE',
  SHARED_COST = 'SHARED_COST',
  VOIP = 'VOIP',
  PERSONAL_NUMBER = 'PERSONAL_NUMBER',
  PAGER = 'PAGER',
  UAN = 'UAN',
  VOICEMAIL = 'VOICEMAIL',
  UNKNOWN = 'UNKNOWN',
}
